import { dimensionsWithinBounds } from '@hotjar/webapp/features/Playbacks/utils/dimensionsWithinBounds';
import type { Store } from '../../../store/player/types';

/**
 * Checks if it's worth trying the incoming dimensions, for use with non-desktops.
 */
export const shouldTryNewDimensions = (store: Store, inX: number, inY: number): boolean => {
  const { recording } = store.getState();
  if (!recording) return false;

  return !dimensionsWithinBounds(recording.window_size) && dimensionsWithinBounds([inX, inY]);
};
